import type { ValidateFunction } from "ajv";
import Ajv2020 from "ajv/dist/2020";
import type { SchemaChecker } from "./public";
import { describeSchemaErrors } from "./schemaProblemText";

/**
 * 스키마 하나의 검사기를 만든다. 컴파일은 첫 검사 때 한 번만 한다. 그래서 모듈을 import 하는 비용이 없다.
 *
 * strict 모드라 스키마에 모르는 키워드나 모호한 규칙이 있으면 첫 검사가 예외를 던진다. 스키마 결함은
 * wire 오류가 아니다. `allErrors` 로 위반을 모두 모은다.
 */
export function createSchemaChecker<T>(schema: object): SchemaChecker<T> {
  let validate: ValidateFunction<T> | null = null;
  return (value) => {
    validate ??= new Ajv2020({ strict: true, allErrors: true })
      .addFormat("uuid", /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i)
      .compile<T>(schema);
    if (validate(value)) {
      return { ok: true, value };
    }
    return { ok: false, problems: describeSchemaErrors(validate.errors ?? []) };
  };
}
